import { render, staticRenderFns } from "./MenuComponent.vue?vue&type=template&id=39410512&scoped=true&"
import script from "./MenuComponent.vue?vue&type=script&lang=js&"
export * from "./MenuComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39410512",
  null
  
)

export default component.exports